import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentMySpaces = styled.div`
  width: 100%;
  height: fit-content;
`;

export const useStyles = makeStyles(() => ({
  containMySpaces: {
    margin: "0",
    width: "100%",
  },
  bodyMySpaces: {
    backgroundColor: theme.neutral.white,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "1.5em",
  },
}));
